import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AddListing from './components/AddListing';
import Home from './pages/Home';
import ListingPage from './pages/ListingPage'; 
import ListingDetailsPage from './pages/ListingDetailsPage';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/add" element={<AddListing />} />
        <Route path="/listings" element={<ListingPage />} /> 
        <Route path="/listings/:id" element={<ListingDetailsPage />} />
      </Routes>
      
      <Footer />
    </Router>
  );
}

export default App;
